module.exports = __webpack_public_path__ + "img/Selbach.fe6edc25.jpg";